import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, unavailable: Boolean }

  connect() {
    this.draftChanged()
    if (this.unavailableValue) this.lost({ detail: { checkAI: true } })
  }

  disconnect() {
    window.clearTimeout(this.timer)
    this.abort?.abort()
  }

  lost(event) {
    this.problem = true
    this.checkAI ||= event?.detail?.checkAI === true
    this.element.textContent = event?.detail?.message || (this.checkAI ? "Нет соединения с ИИ — отправка недоступна. Проверяем восстановление связи…" : "Нет соединения с сайтом — отправка недоступна. Проверяем восстановление связи…")
    this.updateSend(true)
    window.clearTimeout(this.timer)
    this.timer = window.setTimeout(() => this.check(), 3000)
  }

  online() { if (this.problem) this.check() }
  offline() { if (this.monitoring || this.problem) this.lost() }

  updateSend(unavailable) {
    const send = document.querySelector("#chat-form [data-chat-target='send']")
    if (!send) return
    send.dataset.connectionUnavailable = String(unavailable)
    send.title = unavailable ? "Нет соединения — отправка недоступна" : "Отправить сообщение"
    const waiting = Array.from(document.querySelectorAll(".chat-preview")).some((preview) => !preview.querySelector("input[name='ai_request[upload_ids][]']"))
    send.disabled = unavailable || document.querySelector("#ai_request_question")?.disabled || waiting || document.querySelector("#chat-form")?.getAttribute("aria-busy") === "true"
  }

  draftChanged(event) {
    if (event?.type === "input" && event.target.id !== "ai_request_question") return
    this.monitoring = Boolean(document.querySelector("#ai_request_question")?.value.trim() || document.querySelector(".chat-previews .chat-preview"))
    if (this.monitoring) {
      this.checkAI = true
      if (navigator.onLine === false) this.lost()
      else if (!this.timer && !this.busy) this.timer = window.setTimeout(() => this.check(), 700)
    } else if (!this.problem) {
      window.clearTimeout(this.timer)
      this.timer = null
      this.element.textContent = ""
    }
  }

  async check() {
    window.clearTimeout(this.timer)
    this.timer = null
    if ((!this.problem && !this.monitoring) || this.busy || !this.element.isConnected) return
    this.busy = true
    this.abort = new AbortController()
    const timeout = window.setTimeout(() => this.abort.abort(), 6000)
    try {
      const response = await fetch(`${this.urlValue}${this.checkAI ? "?ai=1" : ""}`, { credentials: "same-origin", cache: "no-store", signal: this.abort.signal, headers: { Accept: "application/json" } })
      if ([401, 403].includes(response.status)) {
        this.problem = false
        this.monitoring = false
        this.updateSend(true)
        this.element.textContent = "Для продолжения войдите на сайт заново. Перед обновлением страницы сохраните черновик."
        return
      }
      if (!response.ok || (await response.json()).connected !== true) throw new Error("Offline")
      const restored = this.problem
      this.problem = false
      this.checkAI = false
      this.updateSend(false)
      if (restored) this.element.textContent = "Соединение восстановлено. Ничего повторно не отправлялось. Проверьте чат перед повторной отправкой; для незагруженного фото нажмите «Повторить»."
    } catch {
      // Keep the draft and attachments on this page. Only read-only probes retry.
      if (!this.problem && this.element.isConnected) {
        this.problem = true
        this.element.textContent = "Нет соединения с сайтом или ИИ — отправка недоступна. Черновик и фото остаются на этой странице. Проверяем восстановление связи; время восстановления пока неизвестно."
        this.updateSend(true)
      }
    } finally {
      window.clearTimeout(timeout)
      this.busy = false
      if (this.problem && this.element.isConnected) this.timer = window.setTimeout(() => this.check(), 5000)
      else if (this.monitoring && this.element.isConnected) {
        this.checkAI = true
        this.timer = window.setTimeout(() => this.check(), 10000)
      }
    }
  }
}
